<nav class="navbar navbar-expand-lg navbar-light p-2" style="background-color: #125ba8;">
  <button class="navbar-toggler d-block d-md-none" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="true" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="container ">

    <div class="collapse navbar-collapse d-none d-lg-block" id="navbarNavNo">
      <ul class="nav navbar-nav">
          <li><a href="#"><img class="img-top" src="assets/img/Home.png" alt="Inicio"></a><span class="separator-span">&nbsp;&nbsp;|&nbsp;&nbsp;</span></li>
          <li><a href="#"><img src="assets/img/Inicio_Top.png" alt="Inicio"></a><span class="separator-span">&nbsp;&nbsp;|&nbsp;&nbsp;</span></li>
          <li><a [routerLink]="['/showContact']"><img src="assets/img/Contacto_Top.png" alt="Contacto"></a>
<!--            <span class="separator-span">&nbsp;&nbsp;|&nbsp;&nbsp;</span>-->
          </li>
<!--          <li><a style="display: block; cursor: pointer;" (click)="goToReqCard()"><img src="assets/img/Conoce_Top.png"alt="Solicita tu Tarjeta BanCoppel"></a></li>-->
      </ul>
    </div>

    <div class="collapse navbar-collapse " id="navbarNav">
      <ul class="nav navbar-nav  d-block d-md-none">
          <li><a href="#"><img src="assets/img/Home@2x.png" alt="Inicio" width="18" height="18"></a>&nbsp;
          <a href="#"><img src="assets/img/Inicio_Top@2x.png" alt="Inicio" width="34" height="18"></a></li>
          <li><a [routerLink]="['/showContact']"><img src="assets/img/Contacto_Top@2x.png" alt="Contacto" width="58" height="18" ></a></li>
<!--          <li><a (click)="goToReqCard()"><img src="assets/img/Conoce_Top@2x.png" alt="Solicita tu Tarjeta BanCoppel" width="183" height="18"></a></li>-->
      </ul>
    </div>

    <div class="d-none d-md-block d-lg-none">
      <ul class="nav ">
          <a href="#"><img class="img-top" src="assets/img/Home.png" alt="Inicio"></a><span class="separator-span">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <a href="#"><img src="assets/img/Inicio_Top.png" alt="Inicio"></a><span class="separator-span">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <a [routerLink]="['/showContact']"><img src="assets/img/Contacto_Top.png" alt="Contacto" ></a>
<!--           <span class="separator-span">&nbsp;&nbsp;|&nbsp;&nbsp;</span>-->
<!--          <a  (click)="goToReqCard()"><img src="assets/img/Conoce_Top.png" alt="Solicita tu Tarjeta BanCoppel"></a>-->
      </ul>
    </div>

 </div>



</nav>
<nav class="navbar navbar-light justify-content-between" style="background-color: #ffffff;">
  <div class="container">
    <a class="navbar-brand d-none d-lg-block" href="#"><img src="assets/img/BanCoppel_logo.png" width="213" height="39"></a>
    <a class="navbar-brand d-block d-lg-none" href="#"><img src="assets/img/BanCoppel_logo@2x.png"  width="213" height="39"></a>
   <!-- <a class="navbar-brand d-block d-md-none"><img src="assets/img/Promos_BanCoppel@2x.png" width="71" height="29"></a>
    <a class="navbar-brand d-none d-md-block d-lg-none"><img src="assets/img/Promos_BanCoppel@2x.png" width="132" height="51"></a>
    <a class="navbar-brand d-none d-lg-block"><img src="assets/img/Promos_BanCoppel.png" width="132" height="51"></a>-->

  </div>
</nav>
